import { getCookie, checkUrlImages } from '../utils';

export const PAGE_PRODUCT_DETAIL = '#productDetail';
export const PAGE_ITEM_LIST = '#itemList';
export const PAGE_CART_DETAIL = '#cartDetail';
export const PAGE_CATEGORY_LIST = '#categoryList';
export const PAGE_CATEGORY = '#main';

export const COOKIE_CATEGORY_ID = 'categoryId';
export const COOKIE_CLOSE_WEB_VIEW_URL = 'closeWebViewUrl';
export const COOKIE_COMMERCE_API_URL = `commerceApiUrl`;
export const COOKIE_ORDER_ID = 'orderId';
export const COOKIE_WEBVIEW_URL = 'webViewUrl';
export const COOKIE_IMAGES_URL = 'webViewImagesUrl';
export const COOKIE_IMAGES_CMS_URL = 'cmsImagesUrl';
export const COOKIE_X_API_KEY = 'xApiKey';
export const COOKIE_ACCESS_TOKEN = 'token';
export const COOKIE_REFRESH_TOKEN = 'refreshToken';
export const COOKIE_SUITE_ID = 'locationId'; // LOCATION ID in our API, microsoft calls it SUITE_ID
export const COOKIE_IDENTITY_ID = 'identityId';
export const COOKIE_EVENT_ID = 'eventId';
export const COOKIE_EVENT_TIME = 'eventTime';
export const COOKIE_LOCATION_ID = 'locationId';
export const COOKIE_PACKAGE_ID = 'packageId';
export const COOKIE_REFRESH_TOKEN_URL = 'refreshTokenUrl';
export const COOKIE_CLOSE_WEBVIEW_TO_PREVIOUS_URL = 'closeWebViewToPreviousUrl';
export const COOKIE_MENU_TYPE = 'menuType';
export const COOKIE_SECTION = 'webViewSection';
export const COOKIE_CONFIG_SERVICE = 'configServiceUrl';
export const COOKIE_MOBILE_VERSION = 'userCurrentMobileVersion';
export const COOKIE_SINGLE_NIGHT_RENTAL = 'singleNightRental';
export const COOKIE_CMS_SERVICE_DISCLAIMER = 'cmsServiceDisclaimer';
export const COOKIE_CMS_SPECIAL_NEEDS = 'cmsSpecialNeeds';
export const COOKIE_CMS_ADD_MORE = 'cmsAddMore';

export const requiredCookies = [
    COOKIE_CLOSE_WEB_VIEW_URL,
    COOKIE_COMMERCE_API_URL,
    COOKIE_IMAGES_URL,
    COOKIE_WEBVIEW_URL,
    COOKIE_EVENT_ID,
    COOKIE_IDENTITY_ID,
    COOKIE_SUITE_ID,
    COOKIE_LOCATION_ID,
    COOKIE_MENU_TYPE,
    COOKIE_PACKAGE_ID

    // COOKIE_CATEGORY_ID,
    // COOKIE_X_API_KEY,
    // COOKIE_ACCESS_TOKEN,
    // COOKIE_REFRESH_TOKEN,
    // COOKIE_REFRESH_TOKEN_URL,
    // COOKIE_CLOSE_WEBVIEW_TO_PREVIOUS_URL
];

export const URL_IMAGES = getCookie(COOKIE_IMAGES_URL) ? checkUrlImages(getCookie(COOKIE_IMAGES_URL)) : '';
export const PLACEHOLDER_IMAGE = getCookie(COOKIE_IMAGES_CMS_URL)
    ? `${checkUrlImages(
          getCookie(COOKIE_IMAGES_CMS_URL)
      )}content/dam/intuit-dome/en/mobile/fan-app/suites/assets/MenuItemsPlaceholderImage.png`
    : '';

export const CUSTOM_EVENT_EMPTY_CATEGORY = 'EMPTY_CATEGORY';
export const CUSTOM_EVENT_SESSION_REFRESH_ERROR = 'SESSION_REFRESH_ERROR';

export const ERROR_MESSAGE_TITLE = `We're sorry!`;
export const ERROR_MESSAGE_CATEGORY_ERROR = `Currently there is no menu available for ordering food and beverage for the suite. Please try again later.`;
export const ERROR_MESSAGE_ORDER_ERROR = `There was an error loading your order. Please try again.`;
export const ERROR_MESSAGE_WINDOW_ORDER_ERROR = `Sorry, we couldn't create your order`;

export const DOE_DISABLED_MESSAGE = `Orders from the app are not available today. Please refer to our team assistants to order. Thank you for your understanding.`;
export const SERVICE_DISCLAIMER_MESSAGE = `Please note that all food and beverage items are subject to a 22% service charge plus applicable sales tax. This service charge is not a tip or gratuity and is not distributed to service employees. Additional payment for tips and gratuity for service, if any, is voluntary and at your discretion.`;
export const ADD_MORE_LABEL = `+ ADD MORE ITEMS`;
export const SPECIAL_NEEDS_HEADING = `Any allergies or special needs?`;
export const SPECIAL_NEEDS_MESSAGE = `Specify your needs`;

export const MENU_TYPE_PRE = 'PRE';
export const MENU_TYPE_DOE = 'DOE';
